
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/announcements_on_home_page';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('announcements_on_home_page');
  